import React from 'react';
import { Card, Typography } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const { Text } = Typography;

const SubscriptionSuccessAlert = () => {
  const { t } = useTranslation();

  return (
    <Card 
      style={{ 
        marginBottom: '32px',
        border: '1px solid #d9f7be',
        backgroundColor: '#f6ffed'
      }}
      data-testid="subscription-success-alert"
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <CheckCircleOutlined style={{ color: '#389e0d', fontSize: '20px' }} />
        <Text strong style={{ color: '#389e0d', fontSize: '16px' }}>
          {t('subscription.success_message')}
        </Text>
      </div>
    </Card>
  );
};

export default SubscriptionSuccessAlert; 